import type { ReactNode } from 'react';
import './LayoutFrame.css';

export type LayoutFrameProps = {
  children: ReactNode;
  className?: string;
  sectionClassName?: string;
  narrow?: boolean;
  withSection?: boolean;
  allowHorizontalScroll?: boolean;
  hasBottomAction?: boolean;
  flush?: boolean;
};

export function LayoutFrame({
  children,
  className,
  sectionClassName,
  narrow = false,
  withSection = true,
  allowHorizontalScroll = false,
  hasBottomAction = false,
  flush = false,
}: LayoutFrameProps) {
  const frameClassName = [
    'layout-frame',
    'page-container',
    'page-shell',
    allowHorizontalScroll ? 'layout-frame--allow-x' : '',
    hasBottomAction ? 'has-bottom-action' : '',
    flush ? 'layout-frame--flush' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  if (!withSection) {
    return <div className={frameClassName}>{children}</div>;
  }

  const sectionClasses = [
    'layout-frame__section',
    'layout-section',
    narrow ? 'layout-section--narrow' : '',
    sectionClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={frameClassName}>
      <div className={sectionClasses}>{children}</div>
    </div>
  );
}

export default LayoutFrame;
